import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/app";
import 'firebase/app-check';
require('dotenv').config({ path: ".env." + process.env.NODE_ENV })
const firebaseConfig = {
    apiKey: "AIzaSyC8NYsDBDqLrTCgvRMffLd2VAs6fUrjIlI",
    authDomain: "joshia-t.firebaseapp.com",
    databaseURL: "https://joshia-t.firebaseio.com",
    projectId: "joshia-t",
    storageBucket: "joshia-t.appspot.com",
    messagingSenderId: "674849263836",
    appId: "1:674849263836:web:cf078efa85c38dcc442419",
    measurementId: "G-39DEPW902Q"
};
// Initialize Firebase
export const app = firebase.initializeApp(firebaseConfig);
export const analytics = firebase.analytics();
export const database = firebase.firestore();
export const storage = firebase.storage();


// Auth handler
export const auth = firebase.auth();
export const Gprovider = new firebase.auth.GoogleAuthProvider();

const appCheck = firebase.appCheck();
// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
appCheck.activate(
    process.env.CAPTCHA_TOKEN,

    // Optional argument. If true, the SDK automatically refreshes App Check
    // tokens as needed.
    true);

// Offline Firestore
database.enablePersistence()
    .catch((err) => {
        if (err.code === 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            // ...
        } else if (err.code === 'unimplemented') {
            // The current browser does not support all of the
            // features required to enable persistence
            // ...
        }
    })

export default firebase;